export const formatDate = dateValue => {
  const date = new Date(`${dateValue}T00:00:00`)

  return Number.isNaN(date.getTime()) ? dateValue : new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(date)
}

const formatTime = time => {
  const [hours, minutes] = time.split(':')

  return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(new Date(2000, 0, 1, Number(hours), Number(minutes)))
}

export const scheduleSummary = holiday => {
  if (!holiday.open) {
    return 'Closed'
  }

  return holiday.closing_at ? `Open until ${formatTime(holiday.closing_at)}` : 'Open'
}
